import React from 'react';
import { Avatar, Tooltip } from 'antd';

import { InterviewChatPerson } from 'api/interviewChats/types';

import { initialsOf } from 'helpers/interviewChats';

import styles from './Person.module.scss';

interface PersonProps {
  person: InterviewChatPerson;
  size?: number;
  /** Shown when the pair member could not be resolved (e.g. deleted user). */
  fallbackLabel?: string;
}

const Person: React.FC<PersonProps> = ({
  person,
  size = 24,
  fallbackLabel = 'Unknown',
}) => {
  const label = person.name || person.userId || fallbackLabel;
  const unresolved = !person.name;

  return (
    <div className={styles.person}>
      <Avatar size={size} src={person.avatarUrl || undefined}>
        {initialsOf(person.name)}
      </Avatar>
      <Tooltip title={person.userId || undefined}>
        <span
          className={[styles.personName, unresolved ? styles.personMissing : '']
            .filter(Boolean)
            .join(' ')}
        >
          {label}
        </span>
      </Tooltip>
    </div>
  );
};

export default Person;
